// Chefs & Bakers craft layer (v181). Small, dependency-free, deferred.
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  // safety net for very fast flicks: anything already above the screen counts as seen
  var pending = [];
  var sweepQueued = false;
  var sweep = function () {
    sweepQueued = false;
    pending = pending.filter(function (p) {
      if (p.done) return false;
      if (p.el.getBoundingClientRect().bottom < 0) { p.done = true; p.fn(p.el); if (p.io) p.io.unobserve(p.el); return false; }
      return true;
    });
    if (!pending.length) window.removeEventListener('scroll', queueSweep);
  };
  var queueSweep = function () { if (!sweepQueued) { sweepQueued = true; requestAnimationFrame(sweep); } };

  var onSeen = function (els, fn, opts) {
    if (!els.length) return;
    if (!hasIO) { els.forEach(fn); return; }
    opts = opts || { rootMargin: '0px 0px -12% 0px', threshold: 0.2 };
    var need = opts.threshold || 0;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // seen properly, or already scrolled past during a fast flick
        if ((e.isIntersecting && e.intersectionRatio >= need * 0.98) || e.boundingClientRect.bottom < 0) {
          var rec = records.get(e.target);
          if (rec && !rec.done) { rec.done = true; fn(e.target); }
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: opts.rootMargin || '0px', threshold: [0, need] });
    var records = new Map();
    els.forEach(function (el) { var rec = { el: el, fn: fn, io: io, done: false }; records.set(el, rec); pending.push(rec); io.observe(el); });
    window.addEventListener('scroll', queueSweep, { passive: true });
  };

  /* ---------- 1. Self-drawing doodles ---------- */
  var DOODLES = '.cb-cat__ico svg, .cb-pillar__ico svg, .cb-help__ico svg, .cb-region__ico svg, .cb-stl__ico svg, .cb-seat__track > span svg, .cb-talk__ico svg, .cb-near__ico svg, .cb-colhead__ico svg, .cb-urgent__ico svg, .cb-tag__ico svg';
  var doodles = $$(DOODLES);
  doodles.forEach(function (svg) {
    svg.classList.add('cb-doodle');
    $$('path, circle, rect, line, polyline, ellipse', svg).forEach(function (shape, i) {
      // measure the real stroke length; a normalised pathLength is not honoured everywhere
      var len = 0;
      try { len = shape.getTotalLength ? shape.getTotalLength() : 0; } catch (e) { len = 0; }
      if (!len) return;
      shape.classList.add('cb-stroke');
      shape.style.setProperty('--len', (len + 1).toFixed(1));
      shape.style.setProperty('--n', i);
    });
  });
  onSeen(doodles, function (svg) { svg.classList.add('is-drawn'); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.6 });
  if (!reduce) {
    doodles.forEach(function (svg) {
      var card = svg.closest('a, button, .cb-pillar, .cb-cat, .cb-stl__card, .cb-talk li, .cb-region');
      if (!card) return;
      var replay = function () {
        if (!svg.classList.contains('is-drawn')) return;
        svg.classList.remove('is-redraw'); void svg.getBoundingClientRect(); svg.classList.add('is-redraw');
      };
      card.addEventListener('pointerenter', replay);
      card.addEventListener('focus', replay, true);
      svg.addEventListener('animationend', function (e) { if (e.target === svg) svg.classList.remove('is-redraw'); });
    });
  }

  /* ---------- 2. Paper settle on cards ---------- */
  $$('.cb-cat, .cb-prod, .cb-testimonial, .cb-loc, .cb-pillar, .cb-help__path, .cb-seat__track, .oat-family__card, .oat-locator__branch, .card-wrapper').forEach(function (el) {
    // the timeline cards and the comparison already have their own entrances
    if (el.closest('.cb-stl, .oat-compare')) return;
    el.classList.add('cb-settle');
  });

  /* ---------- 3. Marker stroke, only where a word carries the line ---------- */
  // A heading can choose its own word with data-ink="phrase"; otherwise these
  // picks apply. Headings not listed stay clean, so the stroke keeps its meaning.
  var INK = [
    ['Bacolod-born', 'Bacolod-born'],
    ['Ready when your negosyo', 'negosyo'],
    ['A story measured in cups', 'cups'],
    ['We got the better end', 'better end'],
    ['Drinks people line up for', 'line up'],
    ['Dough teaches patience', 'patience'],
    ['From recipe to livelihood', 'livelihood'],
    ['Planning a bulk order', 'bulk order'],
    ['Side by side, in one cup', 'one cup']
  ];
  var wrapPhrase = function (h, phrase) {
    var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT), node;
    while ((node = walker.nextNode())) {
      var at = node.nodeValue.indexOf(phrase);
      if (at === -1) continue;
      var mid = node.splitText(at);
      mid.splitText(phrase.length);
      var span = document.createElement('span');
      span.className = 'cb-ink';
      mid.parentNode.replaceChild(span, mid);
      span.appendChild(mid);
      return true;
    }
    return false;
  };
  $$('.cb-h2').forEach(function (h) {
    if (h.querySelector('.cb-uline, .cb-ink, .oatlicious-word, em')) return;
    var text = h.textContent.replace(/\s+/g, ' ').trim();
    var phrase = h.getAttribute('data-ink');
    if (!phrase) {
      for (var i = 0; i < INK.length; i++) { if (text.indexOf(INK[i][0]) === 0) { phrase = INK[i][1]; break; } }
    }
    if (phrase) wrapPhrase(h, phrase);
  });
  onSeen($$('.cb-ink'), function (el) { el.classList.add('is-inked'); }, { rootMargin: '0px 0px -15% 0px', threshold: 0.9 });

  /* ---------- 4. Small numbers count up when they arrive ---------- */
  var counters = $$('.cb-hero__meta b, .oat-trust b, .cb-google-rating strong, .cb-region__count').filter(function (el) {
    var t = el.textContent.trim();
    var m = /^(\d{1,3})(\D.*)?$/.exec(t);
    // only small counts; years like 2012 stay as they are
    return m && +m[1] > 3 && +m[1] < 1000 && t.indexOf('.') === -1;
  });
  counters.forEach(function (el) { el.classList.add('cb-count'); });
  if (!reduce) {
    onSeen(counters, function (el) {
      var t = el.textContent.trim(), m = /^(\d+)(.*)$/.exec(t), end = +m[1], rest = m[2] || '';
      var start = performance.now(), dur = Math.min(1400, 500 + end * 4);
      var tick = function (now) {
        var k = Math.min(1, (now - start) / dur), e = 1 - Math.pow(1 - k, 3);
        el.textContent = Math.round(end * e) + rest;
        if (k < 1) requestAnimationFrame(tick); else el.textContent = t;
      };
      el.textContent = '0' + rest;
      requestAnimationFrame(tick);
    }, { threshold: 0.9 });
  }

  /* ---------- 5. Product photo hand-off to the product page ---------- */
  if (document.startViewTransition || 'onpageswap' in window) {
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      var card = link.closest('.card-wrapper, .cb-prod, .card');
      var img = card && card.querySelector('img');
      if (!img) return;
      $$('[style*="cb-product-photo"]').forEach(function (el) { el.style.viewTransitionName = ''; });
      img.style.viewTransitionName = 'cb-product-photo';
    }, true);
    // coming back from a product page, clear the name so it is never duplicated
    window.addEventListener('pageshow', function () {
      $$('img').forEach(function (el) { if (el.style.viewTransitionName === 'cb-product-photo') el.style.viewTransitionName = ''; });
    });
  }

  /* ---------- 6. Workshops: steps tick off as you read ---------- */
  var steps = $$('.cb-pillar--step');
  onSeen(steps, function (el) {
    var i = steps.indexOf(el);
    setTimeout(function () { el.classList.add('is-ticked'); }, reduce ? 0 : 450 + i * 250);
  }, { threshold: 0.75 });

  /* ---------- 7. Collection chips: bring the current one into view ---------- */
  var active = document.querySelector('.cb-chips .cb-chip.active');
  if (active && active.parentElement.scrollWidth > active.parentElement.clientWidth) {
    var row = active.parentElement;
    row.scrollLeft = Math.max(0, active.offsetLeft - row.clientWidth / 2 + active.offsetWidth / 2);
  }

  /* ---------- 8. Pointer light on the newer cards too ---------- */
  if (finePointer && !reduce) {
    // only cards whose own styles don't target their direct children; the help and
    // seat cards already have their own hover, and style every child span
    $$('.oat-family__card, .cb-stl__card').forEach(function (el) {
      if (el.querySelector(':scope > .cb-surface-light')) return;
      el.classList.add('cb-light-surface');
      var light = document.createElement('i');
      light.className = 'cb-surface-light';
      light.setAttribute('aria-hidden', 'true');
      el.insertBefore(light, el.firstChild);
      var frame = 0;
      el.addEventListener('pointermove', function (ev) {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = 0;
          var r = el.getBoundingClientRect();
          el.style.setProperty('--cb-local-x', ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          el.style.setProperty('--cb-local-y', ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      });
      el.addEventListener('pointerleave', function () { el.style.removeProperty('--cb-local-x'); el.style.removeProperty('--cb-local-y'); });
    });
  }
})();
